import React from 'react';
import { FadeIn } from './FadeIn';
export function TargetAudience() {
  return <section className="py-10 px-4 bg-slate-900" data-id="element-282">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-283">
        <FadeIn data-id="element-284">
          <div className="bg-slate-800 p-6 md:p-7 rounded-3xl border border-slate-700 max-w-lg mx-auto" data-id="element-285">
            <h2 className="text-xl md:text-2xl font-bold text-white mb-6" data-id="element-286">
              <span className="text-2xl mr-2" data-id="element-287">🎯</span> ¿Para quién es esto?
            </h2>
            <ul className="space-y-4" data-id="element-288">
              <li className="flex items-start" data-id="element-289">
                <span className="text-lime-500 mr-3 mt-1" data-id="element-290">✔</span>
                <div data-id="element-291">
                  <span className="text-white font-semibold block" data-id="element-292">
                    Estudiantes
                  </span>
                  <span className="text-sm text-slate-400" data-id="element-293">
                    que quieren dejar de dudar
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-294">
                <span className="text-lime-500 mr-3 mt-1" data-id="element-295">✔</span>
                <div data-id="element-296">
                  <span className="text-white font-semibold block" data-id="element-297">
                    Profesionales
                  </span>
                  <span className="text-sm text-slate-400" data-id="element-298">
                    que buscan seguridad
                  </span>
                </div>
              </li>
              <li className="flex items-start" data-id="element-299">
                <span className="text-lime-500 mr-3 mt-1" data-id="element-300">✔</span>
                <div data-id="element-301">
                  <span className="text-white font-semibold block" data-id="element-302">
                    Entrenadores
                  </span>
                  <span className="text-sm text-slate-400" data-id="element-303">
                    que quieren diferenciarse
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </FadeIn>

        {/* Results */}
        <FadeIn data-id="element-304">
          <div className="bg-slate-800/50 rounded-3xl p-6 md:p-8 border border-slate-700 text-center" data-id="element-305">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-8" data-id="element-306">
              <span className="text-2xl mr-2" data-id="element-307">📈</span> ¿Qué resultados podés
              esperar?
            </h2>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3 max-w-3xl mx-auto" data-id="element-308">
              <div className="bg-slate-800 p-3 rounded-xl border border-cyan-500/20 text-sm md:text-base text-slate-200 font-medium" data-id="element-309">
                Más confianza en cada aplicación
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-cyan-500/20 text-sm md:text-base text-slate-200 font-medium" data-id="element-310">
                Menos dudas
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-cyan-500/20 text-sm md:text-base text-slate-200 font-medium" data-id="element-311">
                Decisiones más claras
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-cyan-500/20 text-sm md:text-base text-slate-200 font-medium sm:col-span-2 md:col-span-1 md:col-start-2" data-id="element-312">
                Mayor percepción profesional
              </div>
              <div className="bg-slate-800 p-3 rounded-xl border border-cyan-500/20 text-sm md:text-base text-slate-200 font-medium sm:col-span-2 md:col-span-1" data-id="element-313">
                Independencia real
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Metaphor */}
        <FadeIn data-id="element-314">
          <div className="max-w-2xl mx-auto text-center" data-id="element-315">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-5" data-id="element-316">
              <span className="text-2xl mr-2" data-id="element-317">🧠</span> Pensalo así
            </h2>
            <p className="text-lg md:text-xl text-slate-300 mb-4" data-id="element-318">
              Hoy estás aplicando tape como si armaras un rompecabezas sin la
              imagen.
            </p>
            <p className="text-lg md:text-xl text-slate-300 mb-5" data-id="element-319">
              Con este sistema…
            </p>
            <div className="inline-block bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/50 px-6 py-3 rounded-2xl" data-id="element-320">
              <p className="text-xl md:text-2xl text-white font-bold" data-id="element-321">
                <span className="text-cyan-400 mr-2" data-id="element-322">👉</span> Ves la imagen
                completa.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}